<template>
	<div class="i-button-toggle">
		<btn size="medium" :t="option.value==value?'p':'df'" :l="option.label" :key="index" v-for="(option,index) in options" @press="change(option.value)"/>
	</div>
</template>

<script>
export default {
	props:["options","value"],
  name: 'i-button-toggle',
methods:{
	change(value){
		this.$emit('input',value);
	}
},
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.i-button-toggle{
	display: inline-block;
	    border: 4px solid #e4e4e4;
        border-radius: 16px;
}
</style>
<style>
.i-button-toggle .btn {
    margin-left:-3px !important;
    border-radius: 0 !important;
    margin:0 !important;
}
.i-button-toggle .btn:first-child {
    border-top-left-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
    margin-left:0px !important;
}
.i-button-toggle .btn:last-child {
    border-top-right-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
}


</style>